import axios from 'axios';

const RESOURCE_NAME = '/ecosystem/dashboard';

export default {

    getAddedStartupsCount() {
        return axios.get(`${RESOURCE_NAME}/get-added-startups-count`)
    },

    getAppliedStartupsCount() {
        return axios.get(`${RESOURCE_NAME}/get-applied-startups-count`)
    },

    getEnterprisesCount() {
        return axios.get(`${RESOURCE_NAME}/get-enterprises-count`)
    },

    getRecentlyAddedStartups() {
        return axios.get(`${RESOURCE_NAME}/get-recently-added-startups`)
    },
}